// extracted by mini-css-extract-plugin
export var externalLink = "_84-0";
export var internalLinkLabel = "_84-1";